import Phaser from 'phaser';
import { KIT_ASSETS } from './manifest';

/** Queue all kit textures on a scene loader (nearest / pixel-art). */
export function preloadUiKit(scene: Phaser.Scene): void {
  for (const asset of KIT_ASSETS) {
    if (!scene.textures.exists(asset.textureKey)) {
      scene.load.image(asset.textureKey, asset.path);
    }
  }
}

/** After load: force nearest filtering on kit textures. */
export function hardenUiKitTextures(scene: Phaser.Scene): void {
  for (const asset of KIT_ASSETS) {
    if (!scene.textures.exists(asset.textureKey)) {
      continue;
    }
    scene.textures
      .get(asset.textureKey)
      .setFilter(Phaser.Textures.FilterMode.NEAREST);
  }
}
